import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AuthLogo from "./AuthLogo";

const VerifyView = ({
  siteName,
  username,
  code,
  emailLocked,
  submitting,
  resending,
  inlineError,
  onUsernameChange,
  onCodeChange,
  onSubmit,
  onResendCode,
  onLoginClick
}) => {
  const { t } = useTranslation("common");

  return (
    <>
      <AuthLogo siteName={siteName} />

      <h1 className="auth-title">{t("Verify Account")}</h1>
      <p className="auth-subtitle">
        {t("Enter the verification code we sent to your email to activate your account.")}
      </p>

      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="verify-email">
            {t("Email address")}
          </label>
          <input
            type="email"
            id="verify-email"
            className="form-control"
            placeholder={t("you@company.com")}
            value={username || ""}
            onChange={(event) => onUsernameChange(event.target.value)}
            disabled={emailLocked}
            required
            autoComplete="email"
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="verify-code">
            {t("Code")}
          </label>
          <input
            type="text"
            id="verify-code"
            className="form-control"
            placeholder={t("Enter verification code")}
            value={code}
            onChange={(event) => onCodeChange(event.target.value)}
            required
            autoComplete="one-time-code"
            inputMode="numeric"
          />
        </div>

        <div className={`auth-inline-error ${inlineError ? "visible" : ""}`}>{inlineError}</div>

        <button
          type="submit"
          className="btn btn-gradient btn-lg btn-full"
          disabled={submitting || !username || !code}>
          {submitting ? t("Verifying…") : t("Verify")}
        </button>
      </form>

      <div className="verify-actions">
        <button
          type="button"
          className="btn btn-ghost btn-full"
          onClick={onResendCode}
          disabled={resending || !username}>
          {resending ? `${t("Resending")}...` : t("Resend Code")}
        </button>
      </div>

      <div className="auth-footer" style={{ marginTop: "16px" }}>
        <span>{t("Already verified?")} </span>
        <button type="button" onClick={onLoginClick}>
          {t("Sign in →")}
        </button>
      </div>
    </>
  );
};

VerifyView.propTypes = {
  siteName: PropTypes.string.isRequired,
  username: PropTypes.string,
  code: PropTypes.string.isRequired,
  emailLocked: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  inlineError: PropTypes.string,
  onUsernameChange: PropTypes.func.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired
};

VerifyView.defaultProps = {
  username: "",
  emailLocked: false,
  inlineError: ""
};

export default VerifyView;
